module.exports = __webpack_public_path__ + "static/media/house-desktop.ed781656.svg";